import AxiosConfig from '@/config/axios-config'

export const DashboardAPI = {

  obterQuantidadeQuestoesRespondidas (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/questoes-respondidas',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeDownloadsRealizados (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/downloads-realizados',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterTotalHorasVideosAssistidos (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/horas-videos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeAcessosDisciplinas (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/acessos-usuarios/disciplinas',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeAcessosCursos (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/acessos-usuarios/cursos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeAcessosModulos (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/acessos-usuarios/modulos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeAcessosLicoes (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/acessos-usuarios/licoes',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterQuantidadeTopicosConcluidos (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/topicos-concluidos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterTermosMaisPesquisados (dataInicio, dataFim) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/geral/termos-pesquisados',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim }
      })
      .then(response => response.data)
  },

  obterMediaVideosAssistidos (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/videos-assistidos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterMediaRespostas (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/questoes-respondidas',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterMediaDownloads (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/downloads-realizados',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterDesempenhoDisciplinas (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/desempenho/disciplinas',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterDesempenhoCursos (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/desempenho/cursos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterDesempenhoModulos (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/desempenho/modulos',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterDesempenhoLicoes (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/desempenho/licoes',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  },

  obterAcessoMedioUsuariosTopicos (dataInicio, dataFim, email) {
    return AxiosConfig.secureJalekoAPI().get(
      '/admin/usuario/acesso-medio',
      {
        params: { data_inicio: dataInicio, data_fim: dataFim, email: email }
      })
      .then(response => response.data)
  }

}

export default DashboardAPI
